import { computed } from '@ember/object';
import { not } from '@ember/object/computed';

import Model, { attr, belongsTo, hasMany } from '@warp-drive/legacy/model';

import {
  buildValidations,
  validator,
} from 'umg-ember-backend/utils/validations';

const Validations = buildValidations({
  name: validator('presence', true),
  pass: [
    validator('format', {
      allowBlank: true,
      regex: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
    }),
  ],
  userRoles: [validator('has-many'), validator('presence', true)],
  person: [
    validator('belongs-to'),
    validator('presence', {
      presence: true,
      disabled: not('model.isAdUser'),
    }),
  ],
  userType: validator('presence', true),
});

export default class UserModel extends Model.extend(Validations) {
  @attr('string') description;
  @attr('string') lastActionTime;
  @attr('string') lastLoginIp;
  @attr lastLoginTime;
  @attr({
    defaultValue: function () {
      return {
        entrys: [],
      };
    },
  })
  lastLoginHistory;
  @attr('string') name;
  @attr('string') oid;
  @attr('string') pass;
  @attr('boolean') isAdmin;
  @attr('string') userType;

  // CMS fields
  @attr('number', { defaultValue: 2 }) cmsState;
  @attr('string', { defaultValue: '1' }) cmsLanguageId;
  @attr cmsLivedate;
  @attr cmsKilldate;

  // Meta fields
  @attr cmsCreated;
  @attr cmsDeleted;
  @attr cmsLocktime;
  @attr cmsModified;
  @attr() cmsHistory;
  @belongsTo('user', { async: true, inverse: null }) cmsOwnerId;
  @belongsTo('user', { async: true, inverse: null }) cmsCreatorId;
  @belongsTo('user', { async: true, inverse: null }) cmsLockerId;
  @belongsTo('user', { async: true, inverse: null }) cmsModifierId;

  // Relations
  @belongsTo('person', { async: true, inverse: null }) person;
  @hasMany('artist', { async: true, inverse: null }) artists;
  @hasMany('sftp-user', { async: true, inverse: 'user' }) sftpUsers;
  @hasMany('user-role', { async: true, inverse: null }) userRoles;

  // Getter and setter
  get displayHeadline() {
    return this.name;
  }

  get displayLabel() {
    return this.name;
  }

  get initials() {
    let largeLetters = this.name?.replace(/[a-z]/g, '');

    if (!largeLetters) {
      return this.name?.substring(0, 2).toUpperCase() ?? '??';
    }

    return largeLetters.split('').reverse().join('');
  }

  @computed('userType')
  get isAdUser() {
    return this.userType === 'INTERNAL' || this.userType === 'EXTERNAL';
  }
}
